// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file v1/crypto.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/crypto.proto.
 */
export const file_v1_crypto: GenFile = /*@__PURE__*/
  fileDesc("Cg92MS9jcnlwdG8ucHJvdG8SAnYxIlsKDVNpZ25lZE1lc3NhZ2USDQoFa2V5aWQYASABKAkSDwoHcGF5bG9hZBgCIAEoDBIRCglzaWduYXR1cmUYAyABKAwSFwoPdGltZXN0YW1wTWlsbGlzGAQgASgDIjUKCVB1YmxpY0tleRIUCgVrZXlpZBgBIAEoCVIFa2V5SWQSEgoKZWQyNTUxOXB1YhgCIAEoCSJLCgpQcml2YXRlS2V5EhQKBWtleWlkGAEgASgJUgVrZXlJZBITCgtlZDI1NTE5cHJpdhgCIAEoCRISCgplZDI1NTE5cHViGAMgASgJQixaKmdpdGh1Yi5jb20vZ2FyZXRoZ2VvcmdlL2JhY2tyZXN0L2dlbi9nby92MWIGcHJvdG8z");

/**
 * @generated from message v1.SignedMessage
 */
export type SignedMessage = Message<"v1.SignedMessage"> & {
  /**
   * a unique identifier generated as the SHA256 of the public key used to sign the message.
   *
   * @generated from field: string keyid = 1;
   */
  keyid: string;

  /**
   * the payload
   *
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;

  /**
   * the signature of the payload
   *
   * @generated from field: bytes signature = 3;
   */
  signature: Uint8Array;

  /**
   * the timestamp in milliseconds since epoch when the message was signed. Must be within 5 minutes of the current time.
   *
   * @generated from field: int64 timestampMillis = 4;
   */
  timestampMillis: bigint;
};

/**
 * Describes the message v1.SignedMessage.
 * Use `create(SignedMessageSchema)` to create a new message.
 */
export const SignedMessageSchema: GenMessage<SignedMessage> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 0);

/**
 * @generated from message v1.PublicKey
 */
export type PublicKey = Message<"v1.PublicKey"> & {
  /**
   * a unique identifier generated as the SHA256 of the public key.
   *
   * @generated from field: string keyid = 1 [json_name = "keyId"];
   */
  keyid: string;

  /**
   * @generated from field: string ed25519pub = 2;
   */
  ed25519pub: string;
};

/**
 * Describes the message v1.PublicKey.
 * Use `create(PublicKeySchema)` to create a new message.
 */
export const PublicKeySchema: GenMessage<PublicKey> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 1);

/**
 * @generated from message v1.PrivateKey
 */
export type PrivateKey = Message<"v1.PrivateKey"> & {
  /**
   * a unique identifier generated as the SHA256 of the public key
   *
   * @generated from field: string keyid = 1 [json_name = "keyId"];
   */
  keyid: string;

  /**
   * @generated from field: string ed25519priv = 2;
   */
  ed25519priv: string;

  /**
   * @generated from field: string ed25519pub = 3;
   */
  ed25519pub: string;
};

/**
 * Describes the message v1.PrivateKey.
 * Use `create(PrivateKeySchema)` to create a new message.
 */
export const PrivateKeySchema: GenMessage<PrivateKey> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 2);

